import css from '../content.scss';
export const sizeItemClassNameList = {
  '1': css.sizeItemClassNameSeven,
  '2': css.sizeItemClassNameSeven,
  '3': css.sizeItemClassNameSeven,
  '4': css.sizeItemClassNameSeven,
  '5': css.sizeItemClassNameSeven,
  '6': css.sizeItemClassNameSeven,
  '7': css.sizeItemClassNameSeven,
  '8': css.sizeItemClassNameEight,
  '9': css.sizeItemClassNameNine
};
export const sizeItemInputWrapperClassNameList = {
  '1': css.sizeItemInputWrapperClassSeven,
  '2': css.sizeItemInputWrapperClassSeven,
  '3': css.sizeItemInputWrapperClassSeven,
  '4': css.sizeItemInputWrapperClassSeven,
  '5': css.sizeItemInputWrapperClassSeven,
  '6': css.sizeItemInputWrapperClassSeven,
  '7': css.sizeItemInputWrapperClassSeven,
  '8': css.sizeItemInputWrapperClassEight,
  '9': css.sizeItemInputWrapperClassNine
};
export const sizeItemInputClassNameList = {
  '1': css.sizeItemInputClassSeven,
  '2': css.sizeItemInputClassSeven,
  '3': css.sizeItemInputClassSeven,
  '4': css.sizeItemInputClassSeven,
  '5': css.sizeItemInputClassSeven,
  '6': css.sizeItemInputClassSeven,
  '7': css.sizeItemInputClassSeven,
  '8': css.sizeItemInputClassEight,
  '9': css.sizeItemInputClassNine
};
export const sizeItemInputLabelNameList = {
  '1': css.sizeItemInputLabelClassSeven,
  '2': css.sizeItemInputLabelClassSeven,
  '3': css.sizeItemInputLabelClassSeven,
  '4': css.sizeItemInputLabelClassSeven,
  '5': css.sizeItemInputLabelClassSeven,
  '6': css.sizeItemInputLabelClassSeven,
  '7': css.sizeItemInputLabelClassSeven,
  '8': css.sizeItemInputLabelClassEight,
  '9': css.sizeItemInputLabelClassNine
};